import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import PauseMembershipStructure from "../../components/pause-system/pause-dashboard/PauseMembershipStructure";

const PauseMembership = () => {
  const userInfoData = useSelector(selectUser);

  return <PauseMembershipStructure userInfoData={userInfoData} />;
};

export default PauseMembership;